import {Fragment} from 'react';

import type {ReactNode} from 'react';

export interface TimelineGroup<TItem> {
  id: string;
  header: ReactNode;
  items: TItem[];
}

export interface TimelineTableProps<TItem> {
  groups: TimelineGroup<TItem>[];
  renderItem: (item: TItem, groupId: string) => ReactNode;
  getItemKey: (item: TItem) => string;
  emptyState?: ReactNode;
  className?: string;
  groupClassName?: string;
}

export function TimelineTable<TItem>({
  groups,
  renderItem,
  getItemKey,
  emptyState,
  className,
  groupClassName = 'flex flex-col gap-4'
}: TimelineTableProps<TItem>) {
  if (groups.length === 0 && emptyState) {
    return <>{emptyState}</>;
  }

  return (
    <div className={className}>
      {groups.map(group => (
        <div key={group.id} className={groupClassName}>
          {group.header}
          {group.items.map(item => (
            <Fragment key={getItemKey(item)}>{renderItem(item, group.id)}</Fragment>
          ))}
        </div>
      ))}
    </div>
  );
}
